import React, { useEffect, useMemo, useState } from 'react';
import Table from '../../../../components/Tables/ReportTable';
import { reportHeader } from '../../../../redux/modules/table/common';
import { headerMaker } from '../../../../components/Tables/ExpandedTable/helper';
import reportService from '../../../../services/reports';
import { useSelector } from 'react-redux';
import { checkWorkAndPlan } from '../../../../utils/makeReport';
import Spinner from 'components/Spinner';

export default ({ active }) => {
  const [newHeader, setNewHeader] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const { selectedDate } = useSelector((state) => state.selectedDateReducer);
  const { categories } = useSelector((state) => state.appReducer);

  const createReportHeader = (data) => {
    reportHeader;
    let head = [];
    head = reportHeader;

    if (head.length == 2) {
      data.forEach((item) => {
        let cat = categories.find((itm) => itm._id == item.category);

        if (cat !== undefined)
          head.push({
            Header: cat.title,
            show: true,
            height: 150,
            width: 200,
            columns: [
              {
                width: 50,
                Header: 'Режа',
                accessor: cat._id + 'plan',
              },
              {
                width: 50,
                Header: 'Амалда',
                accessor: cat._id + 'work',
              },
              {
                width: 50,
                Header: 'Фоизи',
                accessor: cat._id + 'percent',
              },
            ],
          });
      });
    }
    setNewHeader(headerMaker(head));
  };

  useEffect(() => {
    setLoading(true);
    if (active) {
      let data = {
        start: selectedDate[0],
        end: selectedDate[1],
      };
      if (active !== '') {
        data = { ...data, group: active };
      }
      reportService
        .getReportByCategory(data)
        .then((res) => {
          createData(res);
        })
        .finally(() => setLoading(false))
        .catch((err) => {
          console.log(err);
        });
    }
  }, [active, selectedDate]);
  // const headers = useMemo(() => , [newHeader]);

  const createData = (data) => {
    createReportHeader(data[0].categorys);
    const rowData = data?.map((item, ind) => {
      let row = {
        id: ind + 1,
        name: item.region?.title,
      };
      item.categorys.forEach((itm) => {
        row[itm.category + 'plan'] = itm.plan;
        row[itm.category + 'work'] = itm.work;
        row[itm.category + 'percent'] =
          checkWorkAndPlan(itm.work, itm.plan) + '%';
      });
      return row;
    });
    setRows(rowData);
  };

  if (loading) return <Spinner maxHeight='100%' />;
  return (
    <Table
      data={rows}
      headers={newHeader}
      withExcel={true}
      tableName='Туманлар бўйича'
      reportsData={rows}
    />
  );
};
